// Copyright (c) 2025 Audere, All Rights Reserved

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { createStyleSheet } from "../utils/styles";
import type { AllowSharingDialogProps } from "../types/projects";

const AllowSharingDialog = (props: AllowSharingDialogProps) => {
  const { open, onClose, onHandleClick } = props;
  const { t } = useTranslation("AllowSharingDialog");
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogContent sx={styles.dialogContent}>
        {" "}
        <DialogTitle sx={styles.dialogTitle}>{t("title")}</DialogTitle>
        <Typography variant="body2" sx={styles.dialogDescription}>
          {t("description")}
        </Typography>
        <DialogActions sx={styles.dialogActions}>
          <Button onClick={onClose} variant="outlined" color="primary">
            {t("common:close")}
          </Button>
          <Button onClick={onHandleClick} variant="contained" color="primary">
            {t("confirm")}
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default AllowSharingDialog;

const styles = createStyleSheet({
  dialogTitle: {
    p: 0,
    mb: 2,
  },
  dialogDescription: {
    mb: 2,
  },
  dialogContent: {
    p: 2,
  },
  dialogActions: { p: 0, mt: 3 },
});
